import { Component, OnInit, Input } from '@angular/core';
import {
    ScanningResultService,
    VulnerabilityItem,
    VulnerabilitySeverity
} from '../service/index';
import { ErrorHandler } from '../error-handler/index';

import { toPromise } from '../utils';
import {ChannelService} from "../channel/channel.service";

@Component({
    selector: 'hbr-vulnerabilities-grid',
    template: `<div class="row"  style="position:relative;">
        <div>  
          <div class="row flex-items-xs-right rightPos">
            <div class="flex-xs-middle option-right">
              <hbr-filter [withDivider]="true" filterPlaceholder="{{'VULNERABILITY.PLACEHOLDER' | translate}}" (filterEvt)="filterVulnerabilities($event)"></hbr-filter>  
              <span class="refresh-btn" (click)="refresh()"><clr-icon shape="refresh"></clr-icon></span>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <clr-datagrid>
              <clr-dg-action-bar>
                <button type="button" class="btn btn-sm btn-secondary" (click)="scanNow()"><clr-icon shape="shield-check" size="16"></clr-icon>&nbsp;{{'VULNERABILITY.SCAN_NOW' | translate}}</button>
              </clr-dg-action-bar>
              <clr-dg-column [clrDgField]="'id'">{{'VULNERABILITY.GRID.COLUMN_ID' | translate}}</clr-dg-column>
              <clr-dg-column [clrDgField]="'severity'">{{'VULNERABILITY.GRID.COLUMN_SEVERITY' | translate}}</clr-dg-column>
              <clr-dg-column [clrDgField]="'package'">{{'VULNERABILITY.GRID.COLUMN_PACKAGE' | translate}}</clr-dg-column>
              <clr-dg-column [clrDgField]="'version'">{{'VULNERABILITY.GRID.COLUMN_VERSION' | translate}}</clr-dg-column>
              <clr-dg-column [clrDgField]="'fixedVersion'">{{'VULNERABILITY.GRID.COLUMN_FIXED' | translate}}</clr-dg-column>
      
              <clr-dg-placeholder>{{'VULNERABILITY.GRID.PLACEHOLDER' | translate}}</clr-dg-placeholder>
              <clr-dg-row *clrDgItems="let res of scanningResults">
                  <clr-dg-cell><a href="{{res.link}}" target="_blank">{{res.id}}</a></clr-dg-cell>
                  <clr-dg-cell [ngSwitch]="res.severity">
                    <span *ngSwitchCase="5" class="label label-danger">{{severityText(res.severity) | translate}}</span>
                    <span *ngSwitchCase="4" class="label label-medium">{{severityText(res.severity) | translate}}</span>
                    <span *ngSwitchCase="3" class="label label-low">{{severityText(res.severity) | translate}}</span>
                    <span *ngSwitchCase="1" class="label">{{severityText(res.severity) | translate}}</span>
                    <span *ngSwitchDefault>{{severityText(res.severity) | translate}}</span>
                  </clr-dg-cell>
                  <clr-dg-cell>{{res.package}}</clr-dg-cell>
                  <clr-dg-cell>{{res.version}}</clr-dg-cell>
                  <clr-dg-cell>
                       <div *ngIf="res.fixedVersion; else elseBlock">
                          <clr-icon shape="wrench" class="is-success" size="20"></clr-icon>&nbsp;<span class="font-color-green">{{res.fixedVersion}}</span>
                       </div>
                      <ng-template #elseBlock>{{res.fixedVersion}}</ng-template>
                  </clr-dg-cell>
                  <clr-dg-row-detail *clrIfExpanded>
                  {{'VULNERABILITY.GRID.COLUMN_DESCRIPTION' | translate}}: {{res.description}}
                  </clr-dg-row-detail>
              </clr-dg-row>
      
              <clr-dg-footer>
                  <span *ngIf="pagination.totalItems">{{pagination.firstItem + 1}} - {{pagination.lastItem + 1}} {{'VULNERABILITY.GRID.FOOT_OF' | translate}}</span>
                   {{pagination.totalItems}} {{'VULNERABILITY.GRID.FOOT_ITEMS' | translate}}
                  <clr-dg-pagination #pagination [clrDgPageSize]="25" [clrDgTotalItems]="scanningResults.length"></clr-dg-pagination>
              </clr-dg-footer>
          </clr-datagrid>
        </div>
      </div>`,
    styles: [`.bar-wrapper{width:120px;height:12px}.bar-state{text-align:center!important}.bar-state-chart{margin-top:2px}.bar-state-error{position:relative;top:-4px}.error-text{position:relative;top:1px;margin-left:-5px;cursor:pointer}.scanning-button{height:24px;margin-top:0;margin-bottom:0;vertical-align:middle;top:-12px;position:relative}.tip-wrapper{display:inline-block;height:10px;max-width:120px}.tip-position{margin-left:-4px}.tip-block{margin-left:-3px}.bar-block-high{background-color:#e62700}.bar-block-medium{background-color:orange}.bar-block-low{background-color:#ff0}.bar-block-none{background-color:green}.bar-block-unknown{background-color:grey}.bar-tooltip-font{font-size:13px;color:#fff}.bar-tooltip-font-title{font-weight:600}.bar-summary{margin-top:12px;text-align:left}.bar-scanning-time{margin-top:12px}.bar-summary-item{margin-top:3px;margin-bottom:3px}.bar-summary-item span:nth-child(1){width:30px;text-align:center;display:inline-block}.bar-summary-item span:nth-child(2){width:28px;display:inline-block}.option-right{padding-right:16px}.refresh-btn{cursor:pointer}.refresh-btn:hover{color:#007cbb}.label.label-medium{background-color:#ffe4a9;border:1px solid orange;color:orange}.tip-icon-medium{color:orange}.label.label-low{background:rgba(251,255,0,.38);color:#c5c50b;border:1px solid #e6e63f}.tip-icon-low{color:#ff0}.font-color-green{color:green}.bar-tooltip-font-larger span{font-size:16px;vertical-align:middle}hr{border-bottom:0;border-color:#aaa;margin:6px -10px}.font-weight-600{font-weight:600}.rightPos{position:absolute;z-index:100;right:35px;margin-top:4px}`]
})
export class ResultGridComponent implements OnInit {
    scanningResults: VulnerabilityItem[] = [];
    dataCache: VulnerabilityItem[] = [];

    @Input() tagId: string;
    @Input() repositoryId: string;

    constructor(
        private scanningService: ScanningResultService,
        private channel: ChannelService,
        private errorHandler: ErrorHandler
    ) { }

    ngOnInit(): void {
        this.loadResults(this.repositoryId, this.tagId);
    }

    loadResults(repositoryId: string, tagId: string): void {
        toPromise<VulnerabilityItem[]>(this.scanningService.getVulnerabilityScanningResults(repositoryId, tagId))
            .then((results: VulnerabilityItem[]) => {
                this.dataCache = results;
                this.scanningResults = this.dataCache.filter((item: VulnerabilityItem) => item.id !== '');
            })
            .catch(error => { this.errorHandler.error(error); });
    }

    // TODO: Should query from back-end service
    filterVulnerabilities(terms: string): void {
        if (terms.trim() === '') {
            this.scanningResults = this.dataCache.filter((item: VulnerabilityItem) => item.id !== '');
        } else {
            this.scanningResults = this.dataCache.filter((item: VulnerabilityItem) => this._regexpFilter(terms, item.package));
        }
    }

    refresh(): void {
        this.loadResults(this.repositoryId, this.tagId);
    }

    severityText(severity: VulnerabilitySeverity): string {
        switch (severity) {
            case VulnerabilitySeverity.HIGH:
                return 'VULNERABILITY.SEVERITY.HIGH';
            case VulnerabilitySeverity.MEDIUM:
                return 'VULNERABILITY.SEVERITY.MEDIUM';
            case VulnerabilitySeverity.LOW:
                return 'VULNERABILITY.SEVERITY.LOW';
            case VulnerabilitySeverity.NONE:
                return 'VULNERABILITY.SEVERITY.NEGLIGIBLE';
            case VulnerabilitySeverity.UNKNOWN:
                return 'VULNERABILITY.SEVERITY.UNKNOWN';
            default:
                return 'UNKNOWN';
        }
    }

    _regexpFilter(terms: string, testedValue: any): boolean {
        let reg = new RegExp('.*' + terms + '.*', 'i');
        return reg.test(testedValue);
    }

    scanNow(): void {
        this.channel.publishScanEvent(this.repositoryId + "/" + this.tagId);
    }
}
